import axios from "axios";
import authHeader from "./auth-header";
import { API_URL } from "./api-uri";

const getBookings = (id_user, page, pageSize) => {
  const params = {
    params: {
      id_user: id_user,
      page: page,
      pageSize: pageSize,
    },
    headers: authHeader(),
  };

  return axios
    .get(API_URL + "Bookings", params)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error('Error fetching bookings:', error);
      throw error; 
    });
};


const getBooking = (id, id_user) => {

  return axios
    .get(API_URL + `Bookings/${id}/?id_user=${id_user}`, { headers: authHeader() })
    .then((response) => {
      return response.data;
    });
};


const upsertBooking = (booking) => {
  return axios
    .put(`${API_URL}Bookings/UpsertBooking/${booking.id}`, booking)
    .then((response) => {
      return response.data;
    });
};

const deleteBooking = (booking_id) => {
  return axios.delete(API_URL + "Bookings/" + booking_id);
};

export default {
  getBookings,
  upsertBooking,
  deleteBooking,
  getBooking
};